import { useEffect, useState } from "react";
import { Select } from "@mobiscroll/react";
import { IonItem, IonText } from "@ionic/react";
import { RoomDetail, useRoomList } from "../../hooks/useRoomList";


import "./CoverRoomSelect.css";

const CoverRoomInputProps = {
  inputStyle: "box",
  labelStyle: "stacked",
  placeholder: "Select Room Swap",
};

interface CoverRoomSelectProps {
  color?: string;
  value?: string | number;
  onChange?: (event: any) => void;
  isOpen?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const renderRoomItem = (item: any) => {
  return (
    <IonItem className={"teacher-select-item"} key={item?.data?.value?._id}>
      <IonText>{item?.data?.value?.Name?.Long}</IonText>
    </IonItem>
  );
};

const CoverRoomSelect: React.FC<CoverRoomSelectProps> = ({
  value,
  color: _color,
  onChange,
  isOpen,
}) => {
  const [remoteData, setRemoteData] = useState<any[]>([]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { myRoomList, myRoomListLoaded } = useRoomList();

  useEffect(() => {
    // Convert myRoomList to an array of objects with a value property and text property
    // myRoomList = [{_id: "123", Name: {Long: "Room 123"}}, {_id: "456", Name: {Long: "Room 456"}}]
    // remoteData = [{value: {_id: "123", Name: {Long: "Room 123"}}, text: "Room 123"}, {value: {_id: "456", Name: {Long: "Room 456"}}, text: "Room 456"}]
    const listData = myRoomList.map((room: RoomDetail) => {
      return {
        value: room.RoomId,
        text: room.NameLong,
      };
    });
    setRemoteData(listData);
  }, [myRoomList]);

  // const renderRoomItem = useCallback((item: any) => {
  //   const data = item.data;
  //   return (
  //     <div className="md-item-template">
  //       <IonIcon icon={homeOutline} color="medium" />
  //       <div className="md-item-template-title">
  //         <span>{data.text}</span>
  //       </div>
  //     </div>
  //   );
  // }, []);

  return (
    <Select
      data={remoteData}
      filter={true}
      inputProps={CoverRoomInputProps}
      onChange={onChange}
      isOpen={isOpen}
      value={value}
    // label="Room Swap"
    // renderItem={renderRoomItem}
    />
  );
};

export default CoverRoomSelect;
